/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Components_Giveaways_Repeatedtooltip1Inputs */

const id_components_giveaways_repeatedtooltip1 = /** @type {(inputs: Components_Giveaways_Repeatedtooltip1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Penawaran ini telah diberikan ${i?.count} kali.`)
};

const ms_components_giveaways_repeatedtooltip1 = /** @type {(inputs: Components_Giveaways_Repeatedtooltip1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tawaran ini telah diberikan ${i?.count} kali.`)
};

const da_components_giveaways_repeatedtooltip1 = /** @type {(inputs: Components_Giveaways_Repeatedtooltip1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dette tilbud er blevet givet væk ${i?.count} gange.`)
};

const de_components_giveaways_repeatedtooltip1 = /** @type {(inputs: Components_Giveaways_Repeatedtooltip1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dieses Angebot wurde ${i?.count} Mal verschenkt.`)
};

const en_us2_components_giveaways_repeatedtooltip1 = /** @type {(inputs: Components_Giveaways_Repeatedtooltip1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`This offer has been gifted ${i?.count} times.`)
};

const es_es2_components_giveaways_repeatedtooltip1 = /** @type {(inputs: Components_Giveaways_Repeatedtooltip1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Esta oferta ha sido regalada ${i?.count} veces.`)
};

const es_mx2_components_giveaways_repeatedtooltip1 = /** @type {(inputs: Components_Giveaways_Repeatedtooltip1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Esta oferta ha sido regalada ${i?.count} veces.`)
};

const fil_components_giveaways_repeatedtooltip1 = /** @type {(inputs: Components_Giveaways_Repeatedtooltip1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ang offer na ito ay naibigay nang ${i?.count} beses.`)
};

const fr_components_giveaways_repeatedtooltip1 = /** @type {(inputs: Components_Giveaways_Repeatedtooltip1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cette offre a été offerte ${i?.count} fois.`)
};

const it_components_giveaways_repeatedtooltip1 = /** @type {(inputs: Components_Giveaways_Repeatedtooltip1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Questa offerta è stata regalata ${i?.count} volte.`)
};

const hu_components_giveaways_repeatedtooltip1 = /** @type {(inputs: Components_Giveaways_Repeatedtooltip1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ez az ajánlat ${i?.count} alkalommal került kiosztásra.`)
};

const nl_components_giveaways_repeatedtooltip1 = /** @type {(inputs: Components_Giveaways_Repeatedtooltip1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dit aanbod is ${i?.count} keer weggegeven.`)
};

const no_components_giveaways_repeatedtooltip1 = /** @type {(inputs: Components_Giveaways_Repeatedtooltip1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Dette tilbudet har blitt gitt bort ${i?.count} ganger.`)
};

const pl_components_giveaways_repeatedtooltip1 = /** @type {(inputs: Components_Giveaways_Repeatedtooltip1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ta oferta została rozdana ${i?.count} razy.`)
};

const pt_br2_components_giveaways_repeatedtooltip1 = /** @type {(inputs: Components_Giveaways_Repeatedtooltip1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`This offer has been gifted ${i?.count} times.`)
};

const pt_components_giveaways_repeatedtooltip1 = /** @type {(inputs: Components_Giveaways_Repeatedtooltip1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Esta oferta foi oferecida ${i?.count} vezes.`)
};

const ro_components_giveaways_repeatedtooltip1 = /** @type {(inputs: Components_Giveaways_Repeatedtooltip1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Această ofertă a fost oferită gratuit de ${i?.count} ori.`)
};

const fi_components_giveaways_repeatedtooltip1 = /** @type {(inputs: Components_Giveaways_Repeatedtooltip1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tämä tarjous on jaettu ilmaiseksi ${i?.count} kertaa.`)
};

const sv_components_giveaways_repeatedtooltip1 = /** @type {(inputs: Components_Giveaways_Repeatedtooltip1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Detta erbjudande har getts bort ${i?.count} gånger.`)
};

const vi_components_giveaways_repeatedtooltip1 = /** @type {(inputs: Components_Giveaways_Repeatedtooltip1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ưu đãi này đã được tặng ${i?.count} lần.`)
};

const tr_components_giveaways_repeatedtooltip1 = /** @type {(inputs: Components_Giveaways_Repeatedtooltip1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bu teklif ${i?.count} kez verildi.`)
};

const cs_components_giveaways_repeatedtooltip1 = /** @type {(inputs: Components_Giveaways_Repeatedtooltip1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tato nabídka byla darována ${i?.count}krát.`)
};

const bg_components_giveaways_repeatedtooltip1 = /** @type {(inputs: Components_Giveaways_Repeatedtooltip1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Тази оферта е подарена ${i?.count} пъти.`)
};

const ru_components_giveaways_repeatedtooltip1 = /** @type {(inputs: Components_Giveaways_Repeatedtooltip1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Это предложение раздавалось ${i?.count} раз.`)
};

const uk_components_giveaways_repeatedtooltip1 = /** @type {(inputs: Components_Giveaways_Repeatedtooltip1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Цю пропозицію дарували ${i?.count} разів.`)
};

const ar_components_giveaways_repeatedtooltip1 = /** @type {(inputs: Components_Giveaways_Repeatedtooltip1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`تم إهداء هذا العرض ${i?.count} مرة.`)
};

const hi_components_giveaways_repeatedtooltip1 = /** @type {(inputs: Components_Giveaways_Repeatedtooltip1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`यह ऑफ़र ${i?.count} बार उपहार में दिया गया है।`)
};

const th_components_giveaways_repeatedtooltip1 = /** @type {(inputs: Components_Giveaways_Repeatedtooltip1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`ข้อเสนอนี้ถูกแจกฟรี ${i?.count} ครั้ง`)
};

const ja_components_giveaways_repeatedtooltip1 = /** @type {(inputs: Components_Giveaways_Repeatedtooltip1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`このオファーは ${i?.count} 回配布されました。`)
};

const zh_cn2_components_giveaways_repeatedtooltip1 = /** @type {(inputs: Components_Giveaways_Repeatedtooltip1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`This offer has been gifted ${i?.count} times.`)
};

const zh_hant1_components_giveaways_repeatedtooltip1 = /** @type {(inputs: Components_Giveaways_Repeatedtooltip1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`This offer has been gifted ${i?.count} times.`)
};

const ko_components_giveaways_repeatedtooltip1 = /** @type {(inputs: Components_Giveaways_Repeatedtooltip1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`This offer has been gifted ${i?.count} times.`)
};

/**
* | output |
* | --- |
* | "This offer has been gifted {count} times." |
*
* @param {Components_Giveaways_Repeatedtooltip1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_giveaways_repeatedtooltip1 = /** @type {((inputs: Components_Giveaways_Repeatedtooltip1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Giveaways_Repeatedtooltip1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_giveaways_repeatedtooltip1(inputs)
	if (locale === "ms") return ms_components_giveaways_repeatedtooltip1(inputs)
	if (locale === "da") return da_components_giveaways_repeatedtooltip1(inputs)
	if (locale === "de") return de_components_giveaways_repeatedtooltip1(inputs)
	if (locale === "en-US") return en_us2_components_giveaways_repeatedtooltip1(inputs)
	if (locale === "es-ES") return es_es2_components_giveaways_repeatedtooltip1(inputs)
	if (locale === "es-MX") return es_mx2_components_giveaways_repeatedtooltip1(inputs)
	if (locale === "fil") return fil_components_giveaways_repeatedtooltip1(inputs)
	if (locale === "fr") return fr_components_giveaways_repeatedtooltip1(inputs)
	if (locale === "it") return it_components_giveaways_repeatedtooltip1(inputs)
	if (locale === "hu") return hu_components_giveaways_repeatedtooltip1(inputs)
	if (locale === "nl") return nl_components_giveaways_repeatedtooltip1(inputs)
	if (locale === "no") return no_components_giveaways_repeatedtooltip1(inputs)
	if (locale === "pl") return pl_components_giveaways_repeatedtooltip1(inputs)
	if (locale === "pt-BR") return pt_br2_components_giveaways_repeatedtooltip1(inputs)
	if (locale === "pt") return pt_components_giveaways_repeatedtooltip1(inputs)
	if (locale === "ro") return ro_components_giveaways_repeatedtooltip1(inputs)
	if (locale === "fi") return fi_components_giveaways_repeatedtooltip1(inputs)
	if (locale === "sv") return sv_components_giveaways_repeatedtooltip1(inputs)
	if (locale === "vi") return vi_components_giveaways_repeatedtooltip1(inputs)
	if (locale === "tr") return tr_components_giveaways_repeatedtooltip1(inputs)
	if (locale === "cs") return cs_components_giveaways_repeatedtooltip1(inputs)
	if (locale === "bg") return bg_components_giveaways_repeatedtooltip1(inputs)
	if (locale === "ru") return ru_components_giveaways_repeatedtooltip1(inputs)
	if (locale === "uk") return uk_components_giveaways_repeatedtooltip1(inputs)
	if (locale === "ar") return ar_components_giveaways_repeatedtooltip1(inputs)
	if (locale === "hi") return hi_components_giveaways_repeatedtooltip1(inputs)
	if (locale === "th") return th_components_giveaways_repeatedtooltip1(inputs)
	if (locale === "ja") return ja_components_giveaways_repeatedtooltip1(inputs)
	if (locale === "zh-CN") return zh_cn2_components_giveaways_repeatedtooltip1(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_giveaways_repeatedtooltip1(inputs)
	return ko_components_giveaways_repeatedtooltip1(inputs)
});
export { components_giveaways_repeatedtooltip1 as "components.giveaways.repeatedTooltip" }